import type { TableCraftFunction } from '@carboncopyco/types';
import {
  Checkbox,
  DropdownFilter,
  InputDate,
  InputTags,
  InputText,
  TextBase,
} from '@carboncopyco/ui';
import { useEffect, useState } from 'react';

export type ParamInputProps = {
  param: TableCraftFunction['params'][0];
  value: string | boolean;
  onChange: (value: string | boolean) => void;
};

const ParamInput = ({ param, onChange, value }: ParamInputProps) => {
  const [dateError, setDateError] = useState(undefined);

  const validateDateInput = () => {
    setDateError(value === '');
  };

  useEffect(() => {
    if (param.type === 'calendar' && dateError !== undefined) {
      validateDateInput();
    }
  }, [dateError, value]);

  return (
    <>
      {param.type === 'input' && (
        <InputText
          size="lg"
          name={param.name}
          placeholder={param.placeholder}
          value={value as string}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
      {param.type === 'select' && (
        <DropdownFilter
          rounded={false}
          size="medium"
          contentWidth="full"
          items={param.options.map((option) => ({
            label: option,
            id: option,
          }))}
          onSelect={onChange}
          selected={value as string}
          placeholder={param.placeholder}
        />
      )}
      {param.type === 'checkbox' && (
        <div className="flex items-center gap-4 min-h-[36px]">
          <Checkbox
            label={
              <div className="flex">
                <TextBase
                  label={param.display_name}
                  color="text-ds-natural-600"
                />
              </div>
            }
            name={param.name}
            checked={value as boolean}
            onChange={(e) => onChange(e.target.checked)}
          />
        </div>
      )}
      {param.type === 'calendar' && (
        <div className="relative">
          <InputDate
            value={value as string}
            onChange={(date) => {
              onChange(date as string);
            }}
            hasTodayButton
            id="date-input"
            maxLength={10}
            onBlur={validateDateInput}
          />
          {dateError && (
            <p className="text-ds-danger font-ds-inter text-ds-200 font-ds-light tracking-ds-tight leading-ds-200 mt-2">
              Please enter a valid date in the format MM/dd/yyyy (e.g.
              01/01/2022)
            </p>
          )}
        </div>
      )}
      {param.type === 'tokens' && (
        <InputTags
          errorIndexes={[]}
          onNewTag={(tags) => {
            const valueToUpdate = tags.length > 0 ? JSON.stringify(tags) : '';
            onChange(valueToUpdate);
          }}
          name="tokens"
          tags={value ? JSON.parse(value as string) : []}
          placeholder={param.placeholder}
          onRemoveTag={(tags) => {
            const valueToUpdate = tags.length > 0 ? JSON.stringify(tags) : '';
            onChange(valueToUpdate);
          }}
          maxHeight={224}
        />
      )}
    </>
  );
};

export default ParamInput;
